module.exports = __webpack_public_path__ + "img/41.99042a59.jpg";